const module = { name: 'swig/SwigClass', exports: {} }; const exports = module.exports;



import { swig_lib_filters as _filters } from '@grins/fd-modules/splits/require-core';



import { swig_lib_utils as utils } from '@grins/fd-modules/splits/require-core';

exports.version = '1.4.2';


const defaultOptions = {
    locals: {},
}


const noop = () => ''


const SwigClass = function (opts) {
    this.options = Object.assign({}, defaultOptions, opts || {});
    const self = this;
    const filters = _filters;
    function getLocals(options) {
        if (!options || !options.locals) {
            return self.options.locals;
        }
        return Object.assign({}, self.options.locals, options.locals);
    }
    this.setFilter = function (name, method) {
        if (typeof method !== 'function') {
            throw new Error('Filter "' + name + '" is not a valid function.');
        }
        filters[name] = method;
    };
    this.run = function (tpl, locals) {
        const context = getLocals({
            locals
        });
        return tpl(self, context, filters, utils, noop);
    };
}
exports.newInstance = opts => new SwigClass(opts);
export default module.exports;